module.exports = __webpack_public_path__ + "static/media/12.802caea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/12.png
// module id = 1450
// module chunks = 0